import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth, useCurrentUser } from "../auth";
import { Alert, Button, Loading } from "./ui";

export default function RequirePermission({
  permission,
  children,
  fallbackPath,
}: {
  permission: string | string[];
  children: React.ReactNode;
  fallbackPath?: string;
}) {
  const { t } = useTranslation("ui");
  const { isLoading } = useAuth();
  const { currentUser, permissions, isCurrentUserLoading, reloadCurrentUser } =
    useCurrentUser();
  if (isLoading || isCurrentUserLoading)
    return <Loading label={t("profileLoading")} />;
  if (!currentUser)
    return (
      <Alert variant="error" title={t("profileError")}>
        <p>{t("profileErrorText")}</p>
        <Button variant="outline" onClick={() => void reloadCurrentUser()}>
          {t("retry")}
        </Button>
      </Alert>
    );
  const required = Array.isArray(permission) ? permission : [permission];
  if (!required.some((item) => permissions.includes(item)))
    return fallbackPath ? (
      <Navigate to={fallbackPath} replace />
    ) : (
      <section className="vl-public-content">
        <h1>{t("forbiddenTitle")}</h1>
        <p>{t("forbiddenText")}</p>
        <Button asChild variant="outline">
          <Link
            to={
              permissions.includes("product.list")
                ? "/products"
                : "/settings?section=account"
            }
          >
            {t(
              permissions.includes("product.list") ? "backProducts" : "account",
            )}
          </Link>
        </Button>
      </section>
    );
  return <>{children}</>;
}
